import WidgetsMgr from 'widgets/widgetsMgr';
import GlobalFlyout from 'widgets/global/GlobalFlyout';
import RedirectToLink from './global/RedirectToLink';

// Synchronous widget list
WidgetsMgr.addWidgetsList('app_vans', () => [
    ['globalFlyout', GlobalFlyout, 'modal'],
    ['redirectToLink', RedirectToLink]
]);

const hasContext = (context) => window.contexts.includes(context);

// Login flyout widget - loaded when loginDialog context is active (from flyout AJAX content)
WidgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('loginDialog'),
    load: () => import(/* webpackChunkName: 'login.vans' */ './account/LoginFlyoutForm')
        .then(d => d.default)
        .then((LoginFlyoutForm) => ({
            listId: 'login.vans',
            widgetsDefinition: () => [
                ['loginFlyoutForm', LoginFlyoutForm]
            ]
        }))
});

WidgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('checkout'),
    load: () => import(/* webpackChunkName: 'checkout.vans' */ './checkout/CheckoutMgrVansMixin')
        .then(d => d.default)
        .then((ShippingFormVansMixin) => ({
            listId: 'checkout.vans',
            widgetsDefinition: () => [
                ['shippingForm', ShippingFormVansMixin, 'shippingForm'] as [string, any, string]
            ]
        }))
});

// Asynchronous widget list that loaded only when getLoadingFlag function return true
WidgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('pdp'),
    load: () => Promise.all([
        import(/* webpackChunkName: 'pdp.vans' */ './product/ProductDetailsVansMixin').then(d => d.default),
        import(/* webpackChunkName: 'pdp.vans' */ './product/FocusHighlighterProductMixin').then(d => d.default)
    ]).then(deps => {
        const [
            ProductDetailsVansMixin,
            FocusHighlighterProductMixin
        ] = deps;

        return {
            listId: 'pdp.vans',
            widgetsDefinition: () => [
                ['productDetail', ProductDetailsVansMixin, 'productDetail'],
                ['focusHighlighter', FocusHighlighterProductMixin, 'focusHighlighter']
            ]
        };
    })
});
